module.exports = __webpack_public_path__ + "static/img/event8.8437b5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event8.png
// module id = odHQ
// module chunks = 1